export const environment = {
  production: true,
  apiUrl: 'https://wasombouw.alpinedigital.dev',
  useWooCommerce: true,
  wooCommerceUrl: 'https://www.wasombouw.nl/wp-json/wc/v3',
  wooCommerceKey: 'ck_eb94055addfcd659dcc554fa9d8dfdd759d532db',
  wooCommerceSecret: 'cs_8ea0dc2a6ad06010612e8e357a3e5b6a4219b4d8',
};
